import { handleJsonResponse, requestGet, SERVICE_URL } from 'util/request';

export const requestChemistryResultsForSample = (barcode: string) =>
  requestGet(`${SERVICE_URL}/chemistry_results_v2/${barcode}`).then(handleJsonResponse);
